import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "component-main-banner" }
const _hoisted_2 = ["onClick", "src"]

import { NCarousel } from "naive-ui";
import { useBanner } from '@/composables/useBanner'

// const props = defineProps({
//   id: String,
//   keyword: String,
//   maxLength: Number
// });


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { bannerList } = useBanner()

function navigate(OutLink: string) {
  window.open(OutLink)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCarousel), { "show-arrow": "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bannerList).data, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "carousel-img",
            onClick: ($event: any) => (navigate(item.OutLink)),
            src: item.HomeImagePath,
            key: index
          }, null, 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})